import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { BsEye } from "react-icons/bs";
import { Button } from "react-bootstrap";
import Nav from "../../../Components/base/nav";
import RichTextEditor from "../../../Components/RichTextEditor"; // Ensure this import is correct
import ChooseImage from "../../../Components/Modal/ChooseImage";
import ActionBar from "../../../Components/Button/ActionBar";
import ContentForm from "../../../Components/Forms/ShowForm";
import ShowSEOForm from "../../../Components/Forms/ShowSEOForm";
import StoryDetails from "../../../Components/Forms/StoryDetails";
import Sidebar from "../../../Components/base/sidebar";
import Delete from "../../../Components/Button/Delete";
import { faWeight } from "@fortawesome/free-solid-svg-icons";
import { toast } from "sonner";

export default function ShortStory() {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state && location.state.id;
  const [banner_image, setBannerImage] = useState<File | null>(null);
  const [poster_image, setPosterImage] = useState<File | null>(null);
  const [thumbnail_image, setThumbnailImage] = useState<File | null>(null);
  const [is_SoldOut, setIs_SoldOut] = useState<boolean>(false);
  const [ticket_group_code, setTicketGroupCode] = useState("");
  const [post_date, setPostDate] = useState("");
  const [buy_date, setBuyDate] = useState("");
  const [due_date, setDueDate] = useState("");
  const [event_date_start, setEventDateStart] = useState("");
  const [event_date_end, setEventDateEnd] = useState("");
  const [event_time_start, setEventTimeStart] = useState("");
  const [event_time_end, setEventTimeEnd] = useState("");
  const [title, setTitle] = useState("");
  const [venue, setVenue] = useState("");
  const [body, setBody] = useState("");
  const [slug, setSlug] = useState("");
  const [url, setUrl] = useState("");
  const [seo_title, setSeo_Title] = useState("");
  const [seo_details, setSeo_Details] = useState("");
  const [item, setItem] = useState<any | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [postID, setPostID] = useState<string | null>(null);
  const [role, setRole] = useState<string | null>(null);

  useEffect(() => {
    const id = location.state && location.state.id;
  }, []);

  const isValidTextFormat = (format: string) => /^[A-Za-z0-9-]+$/.test(format);

  const handleTicketGroupCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTicketGroupCode(e.target.value);
  };

  const handlePostDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPostDate(e.target.value);
  };

  const handleBuyDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setBuyDate(e.target.value);
  };

  const handleDueDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDueDate(e.target.value);
  };

  const handleEventDateStartChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEventDateStart(e.target.value);
  };

  const handleEventDateEndChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEventDateEnd(e.target.value);
  };

  const handleEventTimeStartChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEventTimeStart(e.target.value);
  };

  const handleEventTimeEndChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEventTimeEnd(e.target.value);
  };

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(e.target.value);
  };

  const handleVenueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setVenue(e.target.value);
  };

  const handleBodyChange = (content: string) => {
    setBody(content);
  };

  const handleisSoldOutChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIs_SoldOut(e.target.checked);
  };

  const handleSlugChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newName = e.target.value;

    if (isValidTextFormat(newName) || newName === "") {
      setSlug(newName);
    }
  };

  const handleSeoTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSeo_Title(e.target.value);
  };

  const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSeo_Details(e.target.value);
  };

  const handleUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUrl(e.target.value);
  };

  const handleBannerImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setBannerImage(e.target.files[0]);
    }
  };

  const handlePosterImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setPosterImage(e.target.files[0]);
    }
  };

  const handleThumbnailImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setThumbnailImage(e.target.files[0]);
    }
  };

  // const autosave = async () => {
  //     const formData = new FormData();
  //     formData.append('category', category);
  //     formData.append('sub_category', sub_category);
  //     formData.append('title', title);
  //     formData.append('body', body);
  //     formData.append('seo_title', seo_title);
  //     formData.append('seo_details', seo_details);
  //     formData.append('slug', slug);
  //     formData.append('sub_head', sub_head);
  //     formData.append('photo_by', photo_by);
  //     if (image) {
  //         formData.append('image', image);
  //     }
  //     if (imageUrl) {
  //         formData.append('imageUrl', imageUrl);
  //     }

  //     try {
  //         const authToken = localStorage.getItem('authToken');
  //         if (!authToken) {
  //             return;
  //         }

  //         if (postID) {
  //             await axios.post(`https://stagingbackend.pulp.ph/api/v1/shortStory/save/${postID}`, formData, {
  //                 headers: {
  //                     'Content-Type': 'multipart/form-data',
  //                     Authorization: `Bearer ${authToken}`,
  //                 }

  //             }
  //             );
  //         } else {
  //             const response = await axios.post(`https://stagingbackend.pulp.ph/api/v1/save/shortStory`, formData, {
  //                 headers: {
  //                     'Content-Type': 'multipart/form-data',
  //                     Authorization: `Bearer ${authToken}`,
  //                 }
  //             });
  //             setPostID(response.data.id);
  //         }

  //         setIsSaved(false);

  //     } catch (error) {
  //         console.error('Unable to Autosave Form!', error);
  //     } finally {
  //         setTimeout(() => {
  //             setIsSubmitting(false);
  //         }, 3000);
  //     }
  // };

  // useEffect(() => {
  //     const handler = setTimeout(() => {
  //         autosave();
  //     }, 2000);

  //     return () => {
  //         clearTimeout(handler);
  //     };
  // }, [category, sub_category, title, body, seo_title, seo_details, sub_head, photo_by, image, imageUrl]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("ticket_group_code", ticket_group_code);
    formData.append("post_date", post_date);
    formData.append("buy_date", buy_date);
    formData.append("due_date", due_date);
    formData.append("event_date_start", event_date_start);
    formData.append("event_date_end", event_date_end);
    formData.append("event_time_start", event_time_start);
    formData.append("event_time_end", event_time_end);
    formData.append("title", title);
    formData.append("venue", venue);
    formData.append("body", body);
    formData.append("slug", slug);
    formData.append("url", url);
    formData.append("seo_title", seo_title);
    formData.append("seo_details", seo_details);
    formData.append("is_SoldOut", is_SoldOut ? "1" : "0");
    if (banner_image) {
      formData.append("banner_image", banner_image);
    }
    if (poster_image) {
      formData.append("poster_image", poster_image);
    }
    if (thumbnail_image) {
      formData.append("thumbnail_image", thumbnail_image);
    }

    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        toast.error(<p className="text-[16px]">Authentication token not found!</p>, {
          duration: 1500,
        });

        setIsSubmitting(false);
        return;
      }

      if (postID) {
        await axios.post(`https://stagingbackend.pulp.ph/v1/pulpliveworld/show/${postID}`, formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
      } else {
        const response = await axios.post(`https://stagingbackend.pulp.ph/api/v1/pulpliveworld/show`, formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        setPostID(response.data.id);
      }

      toast.success(<p className="text-[16px]">Content submitted successfully.</p>, {
        duration: 1500,
      });

      setTimeout(() => {
        navigate("/view/post/Show");
      }, 1600);
    } catch (error) {
      console.error("An error occurred during form submission!", error);

      toast.error(<p className="text-[16px]">An error occurred during form submission!</p>, {
        duration: 1500,
      });
    } finally {
      setTimeout(() => {
        setIsSubmitting(false);
      }, 3000);
    }
  };

  // const handleSaveDraft = async () => {
  //     setIsSubmitting(true);

  //     const formData = new FormData();
  //     formData.append('category', category);
  //     formData.append('sub_category', sub_category);
  //     formData.append('title', title);
  //     formData.append('body', body);
  //     formData.append('seo_title', seo_title);
  //     formData.append('seo_details', seo_details);
  //     formData.append('sub_head', sub_head);
  //     formData.append('photo_by', photo_by);
  //     if (image) {
  //         formData.append('image', image);
  //     }
  //     if (imageUrl) {
  //         formData.append('imageUrl', imageUrl);
  //     }

  //     try {
  //         const authToken = localStorage.getItem('authToken');
  //         if (!authToken) {
  //             alert('Authentication token not found!');
  //             setIsSubmitting(false);
  //             return;
  //         }

  //         if (postID) {
  //             await axios.post(`https://stagingbackend.pulp.ph/api/v1/shortStory/save/${postID}`, formData, {
  //                 headers: {
  //                     'Content-Type': 'multipart/form-data',
  //                     Authorization: `Bearer ${authToken}`,
  //                 }
  //             });
  //         } else {
  //             const response = await axios.post(`https://stagingbackend.pulp.ph/api/v1/shortStory`, formData, {
  //                 headers: {
  //                     'Content-Type': 'multipart/form-data',
  //                     Authorization: `Bearer ${authToken}`,
  //                 }
  //             });
  //             setPostID(response.data.id);
  //         }
  //         alert('Draft Saved Successfully !!');
  //     } catch (error) {
  //         console.error('There was an error saving the draft!', error);
  //         alert(`There was an error saving the draft!, ${error}`);
  //     } finally {
  //         setIsSubmitting(false);
  //     }
  // };

  const handleViewShortstory = async () => {
    try {
      if (postID) {
        window.open(`https://stagingbackend.pulp.ph/article/${postID}`, "_blank");
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const storedRole = localStorage.getItem("role");
    setRole(storedRole);
  }, []);

  const handleDelete = async () => {
    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        console.error('Authentication token not found!');

        toast.error(<p className="text-[16px]">Authentication token not found!</p>, {
          duration: 1500,
        });

        return;
      }

      const confirmDelete = window.confirm(
        "Are you sure you want to delete this content?"
      );
      if (!confirmDelete) {
        return; // If user cancels, do nothing
      }

      if (id) {
        await axios.delete(`https://stagingbackend.pulp.ph/api/v1/shortStory/${id}`, 
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        });
      }

      toast.success(<p className="text-[16px]">Content deleted successfully!</p>, {
        duration: 1500,
      });

      setTimeout(() => {
        navigate("/view/post/Show");
      }, 1600);
    } catch (error) {
      console.error("Unable to delete. Please try again.", error);
      
      toast.error(<p className="text-[16px]">Unable to delete. Please try again.</p>, {
        duration: 1500,
      });
    }
  };

  return (
    <>
      <div className="w-full p-5">
        <div className="flex justify-between items-center mb-4">
          <h1 className="GraphikSemibold text-[20px] font-semibold">Create Show</h1>
          <ActionBar
            role={role}
            onSubmit={handleSubmit}
            onView={handleViewShortstory}
            isSubmitting={isSubmitting}
            isSaved={isSubmitting}
          />
        </div>
        
        <div className="py-5 px-4 rounded bg-white">
          <ContentForm
            ticket_group_code={ticket_group_code}
            post_date={post_date}
            buy_date={buy_date}
            due_date={due_date}
            event_date_start={event_date_start}
            event_date_end={event_date_end}
            event_time_start={event_time_start}
            event_time_end={event_time_end}
            title={title}
            venue={venue}
            body={body}
            url={url}
            banner_image={banner_image}
            poster_image={poster_image}
            thumbnail_image={thumbnail_image}
            is_SoldOut={is_SoldOut}
            onSoldOutChange={handleisSoldOutChange}
            onTicketGroupCodeChange={handleTicketGroupCodeChange}
            onPostDateChange={handlePostDateChange}
            onBuyDateChange={handleBuyDateChange}
            onDueDateChange={handleDueDateChange}
            onEventDateStartChange={handleEventDateStartChange}
            onEventDateEndChange={handleEventDateEndChange}
            onEventTimeStartChange={handleEventTimeStartChange}
            onEventTimeEndChange={handleEventTimeEndChange}
            onTitleChange={handleTitleChange}
            onVenueChange={handleVenueChange}
            onBodyChange={handleBodyChange}
            onUrlChange={handleUrlChange}
            onBannerImageChange={handleBannerImageChange}
            onPosterImageChange={handlePosterImageChange}
            onThumbnailImageChange={handleThumbnailImageChange}
          />

          {(role === "IT" || role === "Live") && (
            <ShowSEOForm
              seo_title={seo_title}
              seo_details={seo_details}
              slug={slug}
              onSeoTitleChange={handleSeoTitleChange}
              onDescriptionChange={handleDescriptionChange}
              onSlugChange={handleSlugChange}
            />
          )}
          {/* onClick={() => handleDelete(item.id)} */}
        </div>
      </div>      
    </>
  );
}
